import React, { useEffect, useState } from "react";

import { Container, Table } from "./styles";
import { format } from "date-fns";
import { useNavigate } from "react-router-dom";
import { Pagination, Spin, Button } from "antd";
import Status from "../../../components/status";
import { Message } from "../../../GlobalStyles";
import { toast } from "react-toastify";
import api from "../../../services/api";
import { MdAdd, MdVisibility } from "react-icons/md";

const Depositos = () => {
  const navigate = useNavigate();
  const [deposits, setDeposits] = useState([]);
  const [totalValue, setTotalValue] = useState(0);
  const [depositsTotal, setDepositsTotal] = useState(0);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    loadDeposits(page);
  }, [page]);

  async function loadDeposits(page) {
    setIsLoading(true);
    await api
      .get(`/deposits?page=${page}`)
      .then((response) => {
        setDeposits(response.data.deposits);
        setDepositsTotal(response.data.depositsTotal);
      })
      .catch(({ response }) => {
        if (response) {
          if (response.data) {
            if (response.data.message) {
              toast.warn(response.data.message);
            } else {
              toast.error(
                "Erro Interno. verifique sua conexão e tente novamente"
              );
            }
          } else {
            toast.error(
              "Erro Interno. verifique sua conexão e tente novamente"
            );
          }
        } else {
          toast.error("Erro Interno. verifique sua conexão e tente novamente");
        }
      });
    setIsLoading(false);
  }

  return (
    <Container>
      <div style={{ display: "flex", justifyContent: "space-between" }}>
        <h1>Meus Depositos</h1>
        <Button
          type="primary"
          style={{
            borderRadius: 50,
          }}
          onClick={() => navigate("/admin/adicionar-saldo")}
        >
          <MdAdd size={20} color="#FFF" />
          Adicionar Saldo
        </Button>
      </div>

      {isLoading ? (
        <Spin style={{ marginTop: 50 }} size="large" />
      ) : (
        <>
          <div className="orders">
            {depositsTotal ? (
              <Table>
                <thead>
                  <tr>
                    <td>Nome</td>
                    <td>Descrição</td>
                    <td>Valor(Bonus)</td>
                    <td>Status</td>
                    <td>Ultima atualização</td>
                    <td></td>
                  </tr>
                </thead>
                <tbody>
                  {deposits.map((deposit) => {
                    return (
                      <tr key={deposit.id}>
                        <td style={{ textTransform: "capitalize" }}>
                          {deposit.name}
                        </td>
                        <td style={{ textTransform: "capitalize" }}>
                          {deposit.description || "Sem Descrição"}
                        </td>
                        <td style={{ textTransform: "capitalize" }}>
                          {(deposit.value || 0).toLocaleString("pt-br", {
                            style: "currency",
                            currency: "BRL",
                          })}
                          {!!deposit.bonus &&
                            `
                            (${(deposit.bonus || 0).toLocaleString("pt-br", {
                              style: "currency",
                              currency: "BRL",
                            })})`}
                        </td>
                        <td
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                          }}
                        >
                          <Status
                            status={deposit.status}
                            isPayment={true}
                            style={{
                              fontSize: 11,
                              height: 20,
                              paddingBottom: 2,
                            }}
                          />
                        </td>
                        <td>
                          {format(
                            new Date(deposit.update_at),
                            "dd/MM/yyyy HH:mm"
                          )}
                        </td>
                        <td>
                          {deposit.payment_id && (
                            <MdVisibility
                              size={22}
                              style={{
                                cursor: "pointer",
                              }}
                              onClick={() =>
                                navigate(
                                  `/cliente/pagamento/${deposit.payment_id}`
                                )
                              }
                            />
                          )}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </Table>
            ) : (
              <Message>Nenhum deposito encontrado</Message>
            )}
          </div>
          <center>
            <Pagination
              style={{ marginTop: 15, justifySelf: "center" }}
              defaultCurrent={page + 1}
              onChange={(page) => {
                setPage(page - 1);
              }}
              total={depositsTotal}
              pageSize={30}
            />
          </center>
        </>
      )}
    </Container>
  );
};

export default Depositos;
